import React from 'react';
import { MainHeader } from '../components/mobile/TopShopperHeader';
import EventCard from '../EventCard';
import ActionButton from '../components/common/ActionButton';
import Banner from '../components/common/Banner';
import UpcomingEventWrapper from '../components/common/UpcomingEventWrapper';
import EventsLeaderboard from '../components/mobile/EventsLeaderboard';
import {
  GRAND_PRICE_BANNER,
  EVENT_HEADER_CONTENT,
  COMPONENT_STYLES,
  DESK_COLOUR_FLAG_HANGING_BANNER,
  COLOUR_FLAG_HANGING_BANNER,
  SHOP_MORE_URL
} from '../Constants';

interface GetEventLayoutComponentsObjectProps {
  saleType: string;
  platform: string;
  grandPriceBannerImagePath: string;
  grandPriceBannerHyperlink: string;
  shopMoreHyperlink: string;
  componentsData: Record<string, unknown>;
  onTimerComplete: () => void;
  redirectPage: () => void;
  onClickHowToParticipate: () => void;
  topShopperHeader: string;
  topShopperSubHeader: string;
}

const getEventLayoutComponentsObject = (props: GetEventLayoutComponentsObjectProps): [] => {
  const {
    saleType = '',
    platform = '',
    grandPriceBannerImagePath,
    grandPriceBannerHyperlink,
    shopMoreHyperlink,
    onTimerComplete,
    redirectPage,
    onClickHowToParticipate,
    componentsData: { eventCardData = {}, upcomingEventsData = [], leaderBoardData = [] } = {},
    topShopperHeader,
    topShopperSubHeader,
    topShopperGrand
  } = props;

  const webPlatform = platform === 'website';
  const shopMoreUrl = shopMoreHyperlink || SHOP_MORE_URL;

  const headerProps = {
    ...EVENT_HEADER_CONTENT,
    topShopperHeader,
    topShopperSubHeader,
    platform
  };

  let eventCardProps = {
    platform,
    eventCardData: {
      ...eventCardData,
      eventBannerUrl: webPlatform ? DESK_COLOUR_FLAG_HANGING_BANNER : COLOUR_FLAG_HANGING_BANNER
    },
    onTimerComplete
  };

  const howToParticipateProps = {
    platform,
    onClick: onClickHowToParticipate
  };

  const grandPrizeBannerProps = {
    platform,
    imageSrc: topShopperGrand === 'ON' ? grandPriceBannerImagePath || GRAND_PRICE_BANNER : '',
    // imageSrc: '',
    imageAlt: 'Grand prize banner',
    onClick: () => redirectPage({ type: 'GRAND_PRIZE', data: grandPriceBannerHyperlink })
  };

  const upcomingEventsProps = {
    platform,
    title: 'Upcoming Events',
    btnLabel: 'View All',
    variant: 'slider',
    data: upcomingEventsData,
    onClick: () => redirectPage({ type: 'UPCOMING_EVENTS' })
  };

  const eventLeaderboardProps = {
    platform,
    saleType,
    redirectToEventWinneers: () => redirectPage({ type: 'EVENT_WINNER' }),
    leaderBoardData,
    eventEndsIn: eventCardData ? eventCardData.eventEndsIn || 0 : 0,
    shopMoreUrl
  };

  switch (saleType) {
    case 'PRE_SALE':
      eventCardProps = {
        ...eventCardProps,
        onCTAClick: () => redirectPage({ type: 'EVENT_WINNER' })
      };
      break;
    case 'ACTIVE_SALE':
      eventCardProps = {
        ...eventCardProps,
        shopMoreUrl
      };
      break;
    default: // do nothing
  }

  const eventCardWrapperStyle = webPlatform
    ? COMPONENT_STYLES.eventCard.desktop
    : COMPONENT_STYLES.eventCard.mobile;

  const howToParticipateWrapperStyle = webPlatform
    ? COMPONENT_STYLES.howToParticipate.desktop
    : COMPONENT_STYLES.howToParticipate.mobile;

  const eventLeaderboardWrapperStyle = webPlatform
    ? COMPONENT_STYLES.eventLeaderboard.desktop
    : COMPONENT_STYLES.eventLeaderboard.mobile;

  const eventBannerWrapperStyle = webPlatform
    ? COMPONENT_STYLES.eventBanner.desktop
    : COMPONENT_STYLES.eventBanner.mobile;

  const upcomingEventsWrapperStyle = webPlatform
    ? COMPONENT_STYLES.upcomingEvents.desktop
    : COMPONENT_STYLES.upcomingEvents.mobile;

  const componentObjet = {
    PRE_SALE: [
      {
        id: 'PRE_SALE_COMP_1',
        classes: [],
        Component: MainHeader,
        componentProps: {
          ...headerProps
        },
        wrapper: {
          id: '',
          styles: {
            width: '100%',
            marginBottom: '2rem'
          },
          classes: ''
        }
      },
      {
        id: 'PRE_SALE_COMP_2',
        classes: [],
        Component: EventCard,
        componentProps: {
          ...eventCardProps
        },
        wrapper: { ...eventCardWrapperStyle }
      },
      {
        id: 'PRE_SALE_COMP_3',
        classes: [],
        Component: ActionButton,
        componentProps: {
          btnLabel: webPlatform ? 'How to Participate' : 'How to Participate ?',
          variant: 'big',
          size: 'lg',
          icon: webPlatform ? 'icon-Chevron-Right' : 'icon-Chevron-Down',
          fontWeight: 'bold',
          fontSize: 'lg',
          fullWidth: true,
          ...howToParticipateProps
        },
        wrapper: { ...howToParticipateWrapperStyle }
      },
      {
        id: 'PRE_SALE_COMP_4',
        classes: [],
        Component: Banner,
        componentProps: {
          ...grandPrizeBannerProps
        },
        wrapper: { ...eventBannerWrapperStyle }
      },
      {
        id: 'PRE_SALE_COMP_5',
        classes: [],
        Component: UpcomingEventWrapper,
        componentProps: {
          ...upcomingEventsProps
        },
        wrapper: { ...upcomingEventsWrapperStyle }
      }
    ],
    ACTIVE_SALE: [
      {
        id: 'ACTIVE_SALE_COMP_1',
        classes: [],
        Component: MainHeader,
        componentProps: { ...headerProps },
        wrapper: {
          id: '',
          styles: {
            width: '100%',
            marginBottom: '2rem'
          },
          classes: ''
        }
      },
      {
        id: 'ACTIVE_SALE_COMP_2',
        classes: [],
        Component: EventCard,
        componentProps: {
          ...eventCardProps
        },
        wrapper: { ...eventCardWrapperStyle }
      },
      {
        id: 'HowtoParticipate',
        classes: [],
        Component: ActionButton,
        componentProps: {
          btnLabel: webPlatform ? 'How to Participate' : 'How to Participate ?',
          variant: 'big',
          size: 'lg',
          icon: webPlatform ? 'icon-Chevron-Right' : 'icon-Chevron-Down',
          fontWeight: 'bold',
          fontSize: 'lg',
          fullWidth: true,
          label: 'Okay',
          ...howToParticipateProps
        },
        wrapper: { ...howToParticipateWrapperStyle }
      },
      {
        id: 'ACTIVE_SALE_COMP_4',
        classes: [],
        Component: EventsLeaderboard,
        componentProps: { ...eventLeaderboardProps },
        wrapper: { ...eventLeaderboardWrapperStyle }
      },
      {
        id: 'ACTIVE_SALE_COMP_5',
        classes: [],
        Component: Banner,
        componentProps: {
          ...grandPrizeBannerProps
        },
        wrapper: { ...eventBannerWrapperStyle }
      },
      {
        id: 'ACTIVE_SALE_COMP_6',
        classes: [],
        Component: UpcomingEventWrapper,
        componentProps: {
          ...upcomingEventsProps
        },
        wrapper: { ...upcomingEventsWrapperStyle }
      }
    ],
    POST_SALE: [
      {
        id: 'POST_SALE_COMP_1',
        classes: [],
        Component: MainHeader,
        componentProps: { ...headerProps },
        wrapper: {
          id: '',
          styles: {
            width: '100%',
            marginBottom: '2rem'
          },
          classes: ''
        }
      },
      {
        id: 'POST_SALE_COMP_2',
        classes: [],
        Component: EventCard,
        componentProps: {
          ...eventCardProps
        },
        wrapper: { ...eventCardWrapperStyle }
      },
      {
        id: 'POST_SALE_COMP_4',
        classes: [],
        Component: EventsLeaderboard,
        componentProps: { ...eventLeaderboardProps },
        wrapper: { ...eventLeaderboardWrapperStyle }
      },
      {
        id: 'POST_SALE_COMP_5',
        classes: [],
        Component: Banner,
        componentProps: {
          ...grandPrizeBannerProps
        },
        wrapper: { ...eventBannerWrapperStyle }
      }
    ]
  };

  if (platform === 'website') {
    return componentObjet[saleType]?.slice(1) || [];
  }
  return componentObjet[saleType] || [];
};

export { getEventLayoutComponentsObject };
